import { render } from "./unreadMessagesCount.vue?vue&type=template&id=380d48ce"
import script from "./unreadMessagesCount.vue?vue&type=script&lang=js"
export * from "./unreadMessagesCount.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__